/**
 * OAuth interceptor.
 */

function authInterceptor($q, $rootScope, OAuthToken, CONFIG) {
    'ngInject';
    return {
        request: function (config) {
            config.headers = config.headers || {};

            let avoidToken = CONFIG.nonAuthenticatedUrl.some(item => {
                return config.url.indexOf(item) !== -1;
            });

            // Remove `Authorization` header.
            if (config.headers.hasOwnProperty('Authorization') && avoidToken) {
                delete config.headers.Authorization;
            }

            return config;
        }
    };
}

/**
 * Export `oauthInterceptor`.
 */

export default authInterceptor;



// WEBPACK FOOTER //
// ./client/app/common/auth/auth.interceptor.js